/* eslint-disable react/prop-types */
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { POLICY_STATUS } from '@constants';
import { formatTime } from '@/utils';
import { PolicyStatus } from '../Policies/PolicyStatus';
import useSettings from '../../hooks/useSettings';

import classes from './PolicyDetailHeader.module.css';

const backIcon = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUAgMAAADw5/WeAAAADFBMVEUAAABbX2JgYGBcX2IEGE20AAAAA3RSTlMA3yDHuD3GAAAALklEQVQI12PACTgdQKQ6mJzbACSYysDCN0Ak+////y9ASJAIRBaiEqILagJOAABHEw31Qf2g6QAAAABJRU5ErkJggg==';

/** 获取日期 */
const getCoveragePeriodString = (policyDetail) => {
  const { settingsInfo: { timeZone } = {} } = useSettings();
  const {
    canceledDate, closedDate, policyCreateDate, policyStatus,
  } = policyDetail || {};

  const createTime = policyCreateDate ? `Created at ${formatTime(policyCreateDate, 'MMM DD, YYYY hh:mm A', timeZone)}` : '--';

  switch (policyStatus) {
    case (POLICY_STATUS.ACTIVE): case (POLICY_STATUS.PENDING): case (POLICY_STATUS.EXPIRED): case (POLICY_STATUS.EXPIRE): {
      return policyCreateDate ? createTime : '';
    }
    case (POLICY_STATUS.CLOSED): {
      return `${createTime} · Closed at ${formatTime(closedDate, 'MMM DD, YYYY hh:mm A', timeZone)}`;
    }
    case (POLICY_STATUS.CANCELLED): case (POLICY_STATUS.SURRENDER): {
      return `${createTime} · Canceled at ${formatTime(canceledDate, 'MMM DD, YYYY hh:mm A', timeZone)}`;
    }
    default: {
      return '';
    }
  }
};

export const PolicyDetailHeader = React.memo(({ policyDetail }) => {
  const navigate = useNavigate();

  if (!policyDetail) {
    return null;
  }
  const { policyId, policyStatus } = policyDetail || {};

  const goBack = () => {
    navigate(-1);
  };

  return (
    <div className={classes.header}>
      <div onClick={goBack}>
        <div className={classes.backBlock}>
          <img src={backIcon} className={classes.backIcon} alt="" />
        </div>
      </div>
      <div className={classes.detail}>
        <div className={classes.main}>
          <div className={classes.policyId}>{`#${policyId}`}</div>
          <div className={classes.status}>
            <PolicyStatus status={policyStatus} />
          </div>
        </div>
        <div className={classes.time}>{getCoveragePeriodString(policyDetail)}</div>
      </div>
    </div>
  );
});
